module.exports = __webpack_public_path__ + "img/headshot-tyoon.8fb20279.png";